// assets/flex-config.js
document.addEventListener('DOMContentLoaded', function () {
  // ======= CONFIG & HANDLES =======
  var cfg   = window.FLEXCFG || {};
  var TOKEN = cfg.token || '';
  var MAP_DN= cfg.collectionsByDn || {};
  var LENOPT= cfg.lengthOptionName || 'Länge';

  var COMBOS= Array.isArray(window.FC_COMBINATIONS) ? window.FC_COMBINATIONS : [];
  var FILES = window.FC_FILES || {};
  var HOSES = window.FC_HOSES || {};
  var PH    = window.FC_PLACEHOLDER || '';

  // Root
  var root = document.getElementById('flex-config');
  if (!root) return;

  // ======= DOM NODES =======
  var dnSel    = document.getElementById('dn');
  var leftSel  = document.getElementById('left');
  var rightSel = document.getElementById('right');
  var formRow  = document.getElementById('fc-form-field');
  var formSel  = document.getElementById('form');
  var lenSel   = document.getElementById('length');
  var goBtn    = document.getElementById('go');
  var msgEl    = document.getElementById('msg');

  var customWrap  = document.getElementById('fc-custom-length-wrap');
  var customInput = document.getElementById('lengthCustom');
  var customMsg   = document.getElementById('fc-custom-msg'); // <— Zusatz-Hinweisfeld
  var reqPanel    = document.getElementById('fc-request');
  var formContact = document.getElementById('fc-form');
  var bodyField   = document.getElementById('fc-body');
  var emailField  = document.getElementById('fc-email');
  var noteField   = document.getElementById('fc-note');

  var prevLeft  = document.getElementById('fc-prev-left');
  var prevHose  = document.getElementById('fc-prev-hose');
  var prevRight = document.getElementById('fc-prev-right');

  // ======= HELPERS =======
  function setMsg(s){ if (msgEl) msgEl.textContent = s || ''; }
  function normQuotes(s){ return String(s||'').replace(/[“”„”]/g,'"').replace(/[‚‘’]/g,"'"); }
  function normSpace(s){ return String(s||'').replace(/\s+/g,' ').trim(); }
  function norm(s){ return normSpace(normQuotes(s)); }

  function isBogen(label){
    var v = norm(label).toLowerCase();
    return v.includes('üm-bogen') || v.includes('uem-bogen');
  }
  function toggleFormField(){
    var show = isBogen(leftSel.value||'') && isBogen(rightSel.value||'');
    if (formRow) formRow.style.display = show ? '' : 'none';
    if (show && formSel){
      if(!['c','z'].includes(formSel.value)) formSel.value='c';
    } else if (formSel){
      formSel.value='';
    }
  }

  // Sortierlogik für UI
  function isSpecialLabel(label){
    var v = norm(label).toLowerCase();
    return v.includes('m10') || v.includes('rohrstutzen') || v.includes('quetschverbinder');
  }
  function sizeValue(label){
    var v = norm(label).toLowerCase();
    if (v.includes('1 1/4')) return 1.25;
    if (v.includes('3/8'))   return 0.375;
    if (v.includes('1/2'))   return 0.5;
    if (v.includes('3/4'))   return 0.75;
    if (/(^|[^0-9])1"($|[^0-9])/.test(v) || v.includes(' 1"')) return 1.0;
    return 999;
  }
  function sortForUi(list){
    return list.sort(function(a,b){
      var aS = isSpecialLabel(a), bS = isSpecialLabel(b);
      if (aS !== bS) return aS ? 1 : -1; // Specials ans Ende
      if (!aS && !bS){
        var da=sizeValue(a), db=sizeValue(b);
        if (da!==db) return da-db;
      }
      return String(a).localeCompare(String(b),'de');
    });
  }

  // Mapping Anschluss → Dateinamen
  function sizeCodeFromLabel(label){
    var v = norm(label).toLowerCase();
    if (v.includes('1 1/4')) return '114';
    if (v.includes('3/8'))   return '38';
    if (v.includes('1/2'))   return '12';
    if (v.includes('3/4'))   return '34';
    if (v.startsWith('1"') || v.includes(' 1"')) return '1';
    if (v.includes('m10'))   return 'M10';
    if (v.includes('rohrstutzen')) return 'ROHR';
    if (v.includes('quetschverbinder')) return 'QUETSCH';
    return 'unk';
  }
  function typeFromLabel(label){
    var v = norm(label).toLowerCase();
    if (v.includes('üm-bogen') || v.includes('uem-bogen')) return 'UeM_BOGEN';
    if (v.includes('üm') || v.includes('uem')) return 'UeM';
    if (v.includes('ag')) return 'AG';
    if (v.includes('m10')) return 'M10';
    if (v.includes('rohrstutzen')) return 'ROHR';
    if (v.includes('quetschverbinder')) return 'QUETSCH';
    return 'GEN';
  }
  function urlFromCandidates(names){
    for (var i=0;i<names.length;i++){
      var n = names[i];
      if (FILES[n]) return FILES[n];
    }
    return '';
  }
  function filenameStraight(label, side){
    var typ  = typeFromLabel(label);
    var code = sizeCodeFromLabel(label);
    if (typ === 'UeM')  return [`${code}_UeM_${side}.png`];
    if (typ === 'AG')   return [`${code}_AG_${side}.png`,
                                (code==='34' && side==='links') ? '34_AG_linbks.png' : null].filter(Boolean);
    if (typ === 'M10'){
      if (label.toLowerCase().includes('lang')) return [`M10_Lang_${side}.png`];
      return [`M10_${side}.png`, `M10_${side[0].toUpperCase()+side.slice(1)}.png`, `M10_${side.toLowerCase()}.png`];
    }
    if (typ === 'ROHR')    return [`rohr_${side}.png`];
    if (typ === 'QUETSCH') return [`quetsch_${side}.png`];
    return [];
  }
  function filenameBogen(dn, label, side){
    var code = sizeCodeFromLabel(label); // 38/12/34/1/114
    var orient = 'OBEN';
    var val = (formSel && formSel.value) || 'gerade';
    if (val === 'c') orient = 'UNTEN';
    else if (val === 'z') orient = (side === 'links' ? 'OBEN' : 'UNTEN');
    var k = [];
    k.push(`DN${dn}_${code}_UeM_BOGEN_${orient}_${side}.png`);
    k.push(`DN${dn}-${code}_UeM_BOGEN_${orient}_${side}.png`);
    k.push(`DN${dn}_UeM_BOGEN_${orient}_${side}.png`);
    k.push(`DN${dn}_${code}_UeM_BOGEN_${orient}_${side}2.png`);
    k.push(`DN${dn}_${code}_UeM_BOGEN_${orient}_${side}3.png`);
    return k;
  }
  function fileUrlFor(label, side){
    if (!label) return PH;
    var dn = (dnSel && dnSel.value) || '';
    var isB = isBogen(label);
    var candidates = isB ? filenameBogen(dn, label, side) : filenameStraight(label, side);
    var url = urlFromCandidates(candidates);
    return url || PH;
  }

  // Options füllen
  function resetSelect(sel){ while (sel.options.length>1) sel.remove(1); sel.value=''; }
  function fillLeftOptions(dnVal){
    resetSelect(leftSel);
    if (!dnVal) return;
    var seen = new Set(), vals = [];
    COMBOS
      .filter(c => String(c.dn) === String(dnVal))
      .forEach(function(c){
        [c.left, c.right].forEach(function(lbl){
          var k = norm(lbl);
          if (!seen.has(k)) { seen.add(k); vals.push(lbl); }
        });
      });
    sortForUi(vals);
    vals.forEach(v => leftSel.add(new Option(v, v)));
  }
  function fillRightOptions(dnVal, leftVal){
    resetSelect(rightSel);
    if (!dnVal || !leftVal) return;
    var seen = new Set(), vals = [];
    COMBOS
      .filter(c => String(c.dn) === String(dnVal))
      .forEach(function(c){
        if (norm(c.left) === norm(leftVal)) {
          var k = norm(c.right);
          if (!seen.has(k)) { seen.add(k); vals.push(c.right); }
        }
        if (norm(c.right) === norm(leftVal)) {
          var k2 = norm(c.left);
          if (!seen.has(k2)) { seen.add(k2); vals.push(c.left); }
        }
      });
    sortForUi(vals);
    vals.forEach(v => rightSel.add(new Option(v, v)));
  }
  function setDefaultsAfterOptionsFilled(){
    var pref='3/8" ÜM';
    var oL = Array.from(leftSel.options).find(o=>o.value===pref);
    if (oL) leftSel.value=pref; else if (leftSel.options.length>1) leftSel.selectedIndex=1;
    onLeftChange();
    var oR = Array.from(rightSel.options).find(o=>o.value===pref);
    if (oR) rightSel.value=pref; else if (rightSel.options.length>1) rightSel.selectedIndex=1;
    onRightChange();
  }

  // Preview
  function updateHoseByDn(){
    var dn = dnSel && dnSel.value;
    if (prevHose) prevHose.src = HOSES[String(dn)] || '';
  }
  function updateEnds(){
    if (prevLeft)  prevLeft.src  = leftSel.value  ? fileUrlFor(leftSel.value,'links')  : PH;
    if (prevRight) prevRight.src = rightSel.value ? fileUrlFor(rightSel.value,'rechts') : PH;
  }
  function updatePreview(){ updateHoseByDn(); updateEnds(); }

  // ======= STOREFRONT API =======
  function gql(q,v){
    return fetch("/api/2024-04/graphql.json", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "X-Shopify-Storefront-Access-Token": TOKEN },
      body: JSON.stringify({ query: q, variables: v })
    }).then(function(res){
      if(!res.ok) throw new Error("Storefront API Fehler "+res.status);
      return res.json();
    });
  }

  var QUERY = [
    "query LoadCollection($handle: String!, $cursor: String){",
    "  collectionByHandle(handle: $handle){",
    "    products(first: 250, after: $cursor){",
    "      pageInfo{ hasNextPage endCursor }",
    "      nodes{ handle onlineStoreUrl",
    "        metafields(identifiers:[",
    "          {namespace:\"custom\", key:\"anschluss1\"},",
    "          {namespace:\"custom\", key:\"anschluss2\"},",
    "          {namespace:\"custom\", key:\"form\"}",
    "        ]){ key value }",
    "        options{ name }",
    "        variants(first: 250){ nodes{ id selectedOptions{ name value } } }",
    "      }",
    "    }",
    "  }",
    "}"
  ].join("\n");

  function numToKey(n){
    if(typeof n!=='number'||!isFinite(n)) return '';
    var s=n.toFixed(6).replace(/\.?0+$/,'');
    return s===''?'0':s;
  }
  function lenKey(raw){
    if (!raw) return '';
    var v = norm(raw).toLowerCase().replace(',', '.');
    var m = v.match(/(\d+(?:\.\d+)?)/);
    if (!m) return '';
    var val = parseFloat(m[1]);
    if (!isFinite(val)) return '';
    if (/\bcm\b/.test(v)) return numToKey(val/100);
    return numToKey(val);
  }
  function detectLengthOptionName(optionNames){
    var names=(optionNames||[]).map(o=>String(o.name||'')); 
    var match=names.find(function(n){
      return /l(ä|ae)ng|length|meter/.test(String(n).toLowerCase());
    });
    return match || LENOPT;
  }

  function mapProducts(allNodes, dn){
    return (allNodes||[]).map(function(p){
      var mf={};
      (Array.isArray(p.metafields) ? p.metafields : []).forEach(function(m){
        if (m && typeof m.key === 'string') {
          mf[m.key] = (m.value == null ? "" : String(m.value));
        }
      });
      var lengthOptName = detectLengthOptionName(p.options||[]);
      var byLen = {};
      var variants = (p.variants && p.variants.nodes) || [];
      variants.forEach(function(v){
        var gid=String(v.id||''); var numericId=gid.split('/').pop();
        var so=(v.selectedOptions||[]).find(o=>o && o.name===lengthOptName) ||
               (v.selectedOptions||[]).find(function(o){
                 if(!o) return false;
                 var val=String(o.value||'').toLowerCase();
                 return /\d/.test(val)&&/(cm\b|m\b)/.test(val);
               });
        if (so){ var key=lenKey(so.value); if (key) byLen[key]=numericId; }
      });
      return {
        handle: p.handle,
        url:    p.onlineStoreUrl || ("/products/"+p.handle),
        dn:     dn,
        left:   norm(mf.anschluss1 || ""),
        right:  norm(mf.anschluss2 || ""),
        form:   String(mf.form || "").trim().toLowerCase(), // "c" | "z" | ""
        variantsByLength: byLen
      };
    });
  }

  var CACHE={};
  function loadDN(dn){
    if (CACHE[dn]) return Promise.resolve(CACHE[dn]);
    var handle = MAP_DN[dn];
    if (!handle) return Promise.reject(new Error("Keine Collection für DN "+dn));
    var cursor=null, acc=[];
    function loop(){
      return gql(QUERY,{handle:handle, cursor:cursor}).then(function(res){
        var page = res && res.data && res.data.collectionByHandle && res.data.collectionByHandle.products;
        if (!page) return;
        acc = acc.concat(page.nodes||[]);
        cursor = (page.pageInfo && page.pageInfo.hasNextPage) ? page.pageInfo.endCursor : null;
        if (cursor) return loop();
      });
    }
    return loop().then(function(){ var list=mapProducts(acc,dn); CACHE[dn]=list; return list; });
  }

  function findProduct(list,left,right,selectedForm){
    function clean(x){ return norm(x).toLowerCase(); }
    var L=clean(left), R=clean(right);
    var isBothBogen = isBogen(left) && isBogen(right);
    var formWanted  = (selectedForm || '').toLowerCase();

    function matches(p,a,b){
      var ok = (clean(p.left)===clean(a) && clean(p.right)===clean(b));
      if (!ok) return false;
      if (!isBothBogen) return true;
      return p.form && p.form === formWanted;
    }

    var ex = list.find(p=>matches(p, left, right));
    if (ex) return ex;
    return list.find(p=>matches(p, right, left));
  }

  // ======= SONDERLÄNGE: Regeln & Live-Snapping =======
  var MIN_CUSTOM  = 310;
  var STEP_CUSTOM = 10;

  // blockiere e,+,-,. und Komma bei Eingabe
  if (customInput) {
    customInput.addEventListener('keydown', function(e){
      var bad = ['e','E','+','-','.',' ',','];
      if (bad.includes(e.key)) e.preventDefault();
    });
  }

  function setCustomError(text){
    if (customMsg){
      customMsg.textContent = text || '';
      customMsg.classList.remove('fc-help--note');
      customMsg.classList.add('fc-help--error');
    }
    if (customInput){ customInput.classList.add('fc-input--error'); }
  }
  function setCustomNote(text){
    if (customMsg){
      customMsg.textContent = text || '';
      customMsg.classList.remove('fc-help--error');
      customMsg.classList.add('fc-help--note');
    }
    if (customInput){ customInput.classList.remove('fc-input--error'); }
  }
  function clearCustomHint(){
    if (customMsg){
      customMsg.textContent = '';
      customMsg.classList.remove('fc-help--error','fc-help--note');
    }
    if (customInput){ customInput.classList.remove('fc-input--error'); }
  }

  // Ties (…5) runden nach OBEN: 355 -> 360
  function nearestStep(val){
    if (!Number.isFinite(val)) return val;
    var rem  = val % STEP_CUSTOM;
    if (rem === 0) return val;
    var down = val - rem;
    var up   = down + STEP_CUSTOM;
    return (rem < STEP_CUSTOM / 2) ? down : up;
  }

  // Erzwingt 10er-Schritte live; gibt {ok,value} zurück
  function enforceCustomLength(opts){
    opts = opts || {};
    var showNote = !!opts.showNote;

    var raw = (customInput && customInput.value || '').trim();
    if (raw === '') { clearCustomHint(); return { ok:false, value:null }; }

    var n = parseInt(raw, 10);
    if (!Number.isFinite(n)) { setCustomError('Bitte eine Zahl eingeben.'); return { ok:false, value:null }; }

    if (n < MIN_CUSTOM){
      setCustomError('Mindestens ' + MIN_CUSTOM + ' cm.');
      return { ok:false, value:n };
    }

    var near = nearestStep(n);
    if (near !== n){
      customInput.value = near;
      if (showNote) setCustomNote('Korrigiert auf ' + near + ' cm.');
    } else {
      clearCustomHint();
    }
    return { ok:true, value:near };
  }

// ======= EVENTS =======
  function onDnChange(){
    var dnVal = dnSel.value || '';
    
    // DN-spezifische Container-Breite setzen
    var stage = document.querySelector('.fc-preview__stage');
    if (stage && dnVal) {
      stage.setAttribute('data-dn', dnVal);
    }
    
    resetSelect(leftSel);
    resetSelect(rightSel);
    updateHoseByDn();
    if (!dnVal){ toggleFormField(); updateEnds(); return; }
    fillLeftOptions(dnVal);
    setDefaultsAfterOptionsFilled();
  }
  function onLeftChange(){ fillRightOptions(dnSel.value,leftSel.value); toggleFormField(); updateEnds(); }
  function onRightChange(){ toggleFormField(); updateEnds(); }

  if (dnSel)    dnSel.addEventListener('change', onDnChange);
  if (leftSel)  leftSel.addEventListener('change', onLeftChange);
  if (rightSel) rightSel.addEventListener('change', onRightChange);
  if (formSel)  formSel.addEventListener('change', updateEnds);

  if (lenSel){
    lenSel.addEventListener('change', function(){
      setMsg('');
      var isCustom = (lenSel.value==='__custom__');
      if (isCustom){
        customWrap && customWrap.classList.remove('fc-collapsed');
        reqPanel   && reqPanel.classList.remove('fc-collapsed');
        if (goBtn) goBtn.textContent='Anfrage senden';
        // vorhandenen Wert direkt snappen
        if (customInput && customInput.value) enforceCustomLength({ showNote:true });
      } else {
        customWrap && customWrap.classList.add('fc-collapsed');
        reqPanel   && reqPanel.classList.add('fc-collapsed');
        if (goBtn) goBtn.textContent='Zum Produkt';
        if (customInput){ customInput.value=''; }
        clearCustomHint();
      }
    });
  }

  if (customInput){
    customInput.addEventListener('input',  function(){ enforceCustomLength({ showNote:true }); });
    customInput.addEventListener('change', function(){ enforceCustomLength({ showNote:true }); });
  }

  // ======= GO HANDLER =======
  function onGo(){
    setMsg('');
    var dn = dnSel && dnSel.value;
    var left = leftSel && leftSel.value;
    var right = rightSel && rightSel.value;
    var length = lenSel && lenSel.value;
    var selectedForm = (formSel && formSel.value) || '';

    if(!dn || !left || !right){ setMsg('Bitte DN, Anschluss links & rechts wählen.'); return; }
    if (isBogen(left) && isBogen(right) && !selectedForm){
      setMsg('Bitte die Form wählen (C oder Z).');
      return;
    }

    // Sonderlänge → Anfrage
    if (length === '__custom__'){
      var res = enforceCustomLength({ showNote:true });
      if (!res.ok){
        setMsg('Bitte Sonderlänge in 10-cm-Schritten ab ' + MIN_CUSTOM + ' cm eingeben.');
        customInput && customInput.focus();
        return;
      }
      var cm = res.value;

      if (emailField && !emailField.value){
        setMsg('Bitte eine gültige E-Mail-Adresse angeben.');
        emailField.focus();
        return;
      }

      if (bodyField){
        bodyField.value = [
          'Anfrage Sonderlänge Flexschlauch','',
          '- Nennweite: DN'+(dn||'—'),
          '- Anschluss links: '+(left||'—'),
          '- Anschluss rechts: '+(right||'—'),
          (isBogen(left)&&isBogen(right) ? ('- Form: '+(selectedForm==='c'?'C':'Z')) : ''),
          '- Länge: '+Math.round(cm)+' cm',
          (noteField && noteField.value ? '\n\nHinweise:\n'+noteField.value.trim() : '')
        ].filter(Boolean).join('\n');
      }
      formContact && formContact.submit();
      return;
    }

    // Normale Länge → Produkt/Variante öffnen
    loadDN(dn).then(function(list){
      var prod = findProduct(list,left,right,selectedForm);
      if(!prod){
        setMsg('Keine passende Produktkombination gefunden. Prüfe Metafelder anschluss1/2 und form.');
        return;
      }
      if(length){
        var key=lenKey(length);
        var vid=prod.variantsByLength[key];
        if(vid){ window.location.href=prod.url+'?variant='+encodeURIComponent(vid); return; }
      }
      window.location.href=prod.url;
    }).catch(function(err){
      console.error(err);
      setMsg('Laden fehlgeschlagen. Bitte später erneut versuchen.');
    });
  }

// Info-Icons - verhindere Dropdown-Öffnung auf Mobile
document.querySelectorAll('.fc-info').forEach(function(infoIcon) {
  infoIcon.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Tooltip anzeigen/verstecken (falls du das willst)
    var tooltip = infoIcon.querySelector('.fc-tooltip');
    if (tooltip) {
      // Hier könntest du Tooltip-Logik hinzufügen
    }
  });
  
  infoIcon.addEventListener('touchend', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
});

  if (goBtn) goBtn.addEventListener('click', onGo);

  // ======= INIT =======
  if (dnSel){ dnSel.value='8'; onDnChange(); }
  updatePreview();
});